<script>
import options from './TooltipComponent.options'
export default options
</script>

<template>
  <div
    class="kb-tooltip-component__container"
    aria-live="polite"
    v-if="!!tooltipText"
  >
    <button
      type="button"
      @click="showDialog"
      @keydown.enter="showDialog"
      aria-haspopup="true"
      :aria-expanded="display"
      :aria-label="tooltipAccessibleName"
      tabindex="0"
      class="kb-tooltip-component__tooltip-button"
      ref="highlighted"
    >
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
        <rect x=".5" y=".5" width="19" height="19" rx="9.5" stroke="#BFBFB7" />
        <path
          d="M9.808 4C8.272 4 6.896 4.704 6 6.064l.944.8c.624-1.088 1.616-1.696 2.848-1.696 1.504 0 2.496.928 2.496 2.32s-1.04 2.336-2.544 2.336H9.04v2.672h1.184V10.88c1.968-.176 3.296-1.488 3.296-3.408C13.52 5.408 12.032 4 9.808 4Zm-.176 9.856a.826.826 0 0 0-.832.832c0 .48.368.832.832.832a.816.816 0 0 0 .832-.832.826.826 0 0 0-.832-.832Z"
          fill="#BFBFB7"
        />
      </svg>
    </button>

    <template v-if="display">
      <div class="kb-tooltip-component" aria-tooltip ref="wordPopup">
        <div class="kb-tooltip-component__triangle" ref="arrow"></div>

        <button
          class="kb-tooltip-component__close"
          aria-label="luk"
          ref="closeButton"
          @keydown="tapTrap"
          @click="closeDialog"
        >
          <div class="kb-ui-icon kb-ui-icon--ui-close"></div>
        </button>

        <p class="kb-tooltip-component__definition">{{ tooltipText }}</p>
      </div>
    </template>
  </div>
</template>
